import { BinaryOperatorNode } from './binary-operator-node';

export class XorNode extends BinaryOperatorNode {
    public evaluate(): boolean {
        return this.left.evaluate() !== this.right.evaluate();
    }
}
